// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2rCy_","inner":"styles_inner__ZIZJK","right":"styles_right__2tJeS","close":"styles_close__3QTvl","footer":"styles_footer__2bxlr"};